import React, { useContext, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import NoSsr from '@components/common/noSsr';
import FilterLayer from '@components/jobs/filterLayer';
import BigCalendar from '@components/jobs/bigCalendar';
import MiniCalendar from '@components/jobs/miniCalendar';
import { CalendarContext, BigCalendarWrap } from '@components/jobs/contextWrap';
import { useUpdateCalendarFilter } from '@repository/calendar/useCalendar';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { CalendarFilterFormVO } from '@domain/vo/calendar/CalendarFilterFormVO';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './jobs.module.scss';

const cx = classnames.bind(styles);

export interface PopUpPosition {
  x: number;
  y: number;
}

export type LatestOpenType = 'FILTER' | 'JOBPOST' | null;

const Jobs = () => {
  const { miniCalendarInfo, filter } = useContext(CalendarContext);

  //esc처리 플래그(필터, 팝업 중 먼저 닫힐 것 판단)
  const [latestOpen, setLatestOpen] = useState<LatestOpenType>(null);
  //캘린더 focus Flag : 미니캘린더 선택, 오늘 버튼 클릭시에만 동작
  const [isFocusDate, setIsFocusDate] = useState(true);

  // 캘린더 필터 저장
  const { mutate: updateCalendarFilter } = useUpdateCalendarFilter();

  //유저정보 조회
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;

  const methods = useForm<CalendarFilterFormVO>({
    defaultValues: filter.latestFilter,
  });

  //필터 적용 버튼 클릭시
  const onClickConfirm = (vo: CalendarFilterFormVO) => {
    filter.setLatestFilter(vo);
    filter.setVisibleFilter(false);
    if (isLogin) updateCalendarFilter(vo);
  };

  //focus animation처리 함수
  useEffect(() => {
    const date = DateFormat.format(miniCalendarInfo.selectedDate, 'yyyy-MM-dd');
    const dateEl = document.getElementById(date);
    const onAnimationEnd = () => setIsFocusDate(false);

    dateEl?.addEventListener('animationend', onAnimationEnd);
    return () => dateEl?.removeEventListener('animationend', onAnimationEnd);
  }, [miniCalendarInfo.selectedDate]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onClickConfirm)}>
        <div className={cx('calendarArea')}>
          {/* 작은 캘린더 영역 */}
          <NoSsr>
            <MiniCalendar setIsFocusDate={setIsFocusDate} />
          </NoSsr>
          {/* 큰 캘린더 영역 */}
          <BigCalendarWrap>
            <BigCalendar isFocusDate={isFocusDate} setLatestOpen={setLatestOpen} setIsFocusDate={setIsFocusDate} />
          </BigCalendarWrap>

          {/* 필터 영역 */}
          <FilterLayer isEnableKeyDown={latestOpen === 'FILTER'} setLatestOpen={setLatestOpen} />
        </div>
      </form>
    </FormProvider>
  );
};

export default Jobs;
